export default __webpack_public_path__ + "static/media/notitification.39049adf.svg";